import i18n from '@shared/config/i18n';
import {
  ChildBase,
  invocesToken,
  reloadSaveStatuses,
  saveToken,
  toReadonlyToken,
} from '../../defaults';
import {
  changeHashMapParamActions,
  changeHashMapParamTriggers,
} from './change-hash-map-param';
import { deleteExistedActions, deleteExistedTriggers } from './delete-existed';
import { saveExistedActions, saveExistedTriggers } from './save-existed';
import { saveNewActions, saveNewTriggers } from './save-new';
import { validationActions, validationTriggers } from './validation';

const { t } = i18n;

/* eslint-disable */
export const saveButton: ChildBase = {
  spec: 'button-text',
  token: saveToken,
  data: {
    label: t('Save')!,
    visible: false,
    customData: {
      buttonText: { startIcon: 'Check' },
      saveStatus: null,
      [reloadSaveStatuses['saved-existed']]: false,
      [reloadSaveStatuses['save-delete']]: false,
      [reloadSaveStatuses['saved-new']]: false,
    },
  },
  meta: {
    /** TRIGGERS */

    triggers: [
      ...changeHashMapParamTriggers,
      ...validationTriggers,
      ...saveExistedTriggers,
      ...saveNewTriggers,
      ...deleteExistedTriggers,

      {
        events: ['data-fetch-error'],
        targets: [saveToken],
        handlers: ['saveStatus-to-default'],
      },

      {
        events: ['data-fetch-success'],
        targets: [saveToken],
        handlers: ['saveStatus-to-default', 'reload-invoces'],
        expr: {
          type: 'func',
          value: `({hashMap}) => {
  if (!!hashMap['${invocesToken}'].data.pending) return false

  const saveStatus = hashMap['${saveToken}'].data.customData.saveStatus
  return saveStatus === '${reloadSaveStatuses['saved-existed']}' || saveStatus === '${reloadSaveStatuses['saved-new']}' || saveStatus === '${reloadSaveStatuses['save-delete']}'
}`,
        },
      },
    ],

    /** ACTIONS */

    actions: [
      ...changeHashMapParamActions,
      ...validationActions,
      ...saveExistedActions,
      ...saveNewActions,
      ...deleteExistedActions,

      {
        kind: 'changes',
        token: 'saveStatus-to-default',
        spec: {
          target: saveToken,
          changes: {
            'data.customData.saveStatus': {
              type: 'val',
              value: null,
            },
          },
        },
      },

      {
        kind: 'event',
        token: 'reload-invoces',
        spec: {
          event: ['on-click'],
          target: [toReadonlyToken],
          data: {},
        },
      },
    ],
  },
};
/* eslint-enable */
